import React, { forwardRef, useState } from "react";
import CardsSliderCard from "./CardsSliderCard";
import { Mousewheel, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import Image from "next/image";
import { useRouter } from "next/router";
import { isMobileContext } from "../../contexts/isMobileContext";
import { useContext } from "react";
import { BASE_URL } from "../../utils/FetchData";
import Magnitizer from "../Animations/Magnitizer";
import FadeIn from "../Animations/FadeIn";

// eslint-disable-next-line react/display-name
const CardsSlider = forwardRef(({ Img_Desktop, Img_Mobile, data, header }, ref) => {
  const { locale } = useRouter();
  const { isMobile } = useContext(isMobileContext);
  const [slideNumber, setSlideNumber] = useState(isMobile ? 4 : 4);
  return (
    <div className="cards-slider-section" ref={ref}>
      <div className="bg-image">
        <div className="overlay"></div>
        {data?.ImageDesktop?.data?.attributes?.url && (
          <Image
            src={`${
              BASE_URL +
              (isMobile
                ? data?.ImageMobile?.data?.attributes?.url
                : data?.ImageDesktop?.data?.attributes?.url)
            }`}
            alt="card"
            layout="fill"
            objectFit="cover"
            priority
          />
        )}
      </div>
      <FadeIn customClass="header light">
        <h3 className="_eleX">{data?.Headline}</h3>
      </FadeIn>
      <FadeIn customClass="swiper-container">
        <Swiper
          key={"cards-slider"}
          style={{ direction: locale == "ar" ? "rtl" : "ltr" }}
          modules={[Navigation, Pagination, Mousewheel]}
          navigation={{
            nextEl: ".swiper-button-next-cards-slider",
            prevEl: ".swiper-button-prev-cards-slider",
          }}
          className="swiper-cards-slider-section"
          slidesPerView={1}
          spaceBetween={20}
          breakpoints={{
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
          }}
          pagination={{
            type: "progressbar",
            el: ".swiper-cards-slider-pagination",
          }}
          onSlideChange={(swiper) => {
            setSlideNumber(
              isMobile ? 1 + swiper.activeIndex : 4 + swiper.activeIndex
            );
          }}
          // loop={true}
        >
          {data?.WhyUsWorksCards?.map((item, index) => (
            <SwiperSlide key={index}>
              {item?.Image?.data?.attributes?.url &&
              <CardsSliderCard
                index={index}
                img={
                  BASE_URL +
                  (isMobile
                    ? item?.Image?.data?.attributes?.url
                    : item?.Image?.data?.attributes?.url)
                }
                // title={item?.Facilitie_Name}
                description={item?.Title}
              />
              }
            </SwiperSlide>
          ))}
        </Swiper>
      </FadeIn>
      <div
        className="swiper-navigation-continer"
        style={{
          display: !isMobile && data?.WhyUsWorksCards?.length <= 4 ? "none" : "flex",
        }}
      >
        <div className="navigation-container">
          <div className="slide-number-container bold">
            <div>
              {slideNumber.toLocaleString("en-US", { minimumIntegerDigits: 2 })}
            </div>
            <div>
              {data?.WhyUsWorksCards?.length.toLocaleString("en-US", {
                minimumIntegerDigits: 2,
              })}
            </div>
          </div>
          <div className="swiper-cards-slider-pagination swiper-pagination-progressbar"></div>
        </div>
        <div className="arrows-container">
          <Magnitizer dataDest={1.5}>
            <div className="swiper-button-prev swiper-button-prev-cards-slider cards-slider-arrow"></div>
          </Magnitizer>
          <Magnitizer dataDest={1.5}>
            <div className="swiper-button-next swiper-button-next-cards-slider cards-slider-arrow"></div>
          </Magnitizer>
        </div>
      </div>
    </div>
  );
});

export default CardsSlider;
